import { apiClient, createNewAxiosInstance } from './apiService';
export const logLogin = async () => {
  await logLoginApi();
};
export const logLogout = async () => {
  await logLogoutApi();
};
export const logSection = async (section: string) => {
  await logSectionApi(section);
};
export const logSectionApi = async (section: string) => {
  try {
    const response = await apiClient.post(
      `/api/usersManagement/userUsage/registerSection/${section}`
    );
    return response.status === 200;
  } catch (ex) {
    console.error(ex);
    return false;
  }
};
export const logLoginApi = async () => {
  try {
    const newApiInstance = createNewAxiosInstance();
    const response = await newApiInstance.post(
      '/api/usersManagement/userUsage/registerLogin'
    );
    return response.status === 200;
  } catch (ex) {
    console.error(ex);
    return false;
  }
};
export const logLogoutApi = async () => {
  try {
    const response = await apiClient.post(
      '/api/usersManagement/userUsage/registerLogout'
    );
    return response.status === 200;
  } catch (ex) {
    console.error(ex);
    return false;
  }
};
